import { render, staticRenderFns } from "./OrderNotes.vue?vue&type=template&id=7a00897b&scoped=true&"
import script from "./OrderNotes.vue?vue&type=script&lang=js&"
export * from "./OrderNotes.vue?vue&type=script&lang=js&"
import style0 from "./OrderNotes.vue?vue&type=style&index=0&id=7a00897b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a00897b",
  null
  
)

export default component.exports